import { render, staticRenderFns } from "./HousemateGroupModal.vue?vue&type=template&id=a492d52e"
import script from "./HousemateGroupModal.vue?vue&type=script&lang=js"
export * from "./HousemateGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports